import React from 'react';

const BibleVerse: React.FC = () => {
  return (
    <section className="bible-verse-section">
      {/* Background with gradient using existing palette */}
      <div className="bible-verse-background">
        <div className="bible-verse-background-overlay"></div>
      </div>

      {/* Header */}
      <div className="bible-verse-header">
        <h1 className="bible-verse-subtitle">
          PALABRA DE DIOS
        </h1>
        <h2 className="bible-verse-title-script">
          Una Promesa de Amor
        </h2>
      </div>

      {/* Content */}
      <div className="bible-verse-content">
        <div className="verse-card">
          {/* <div className="bible-verse-icon">✝</div> */}
          <div>
            <svg
              className="bible-verse-icon"
              width="56"
              height="56"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              {/* Libro */}
              <path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
              {/* Cruz con proporción correcta (travesaño a 1/3 desde arriba) */}
              <path d="M12 7v9m-3-6.5h6" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>

          <div className="verse-text-container">
            <p className="verse-text">
              "El amor es paciente, es bondadoso. El amor no es envidioso ni jactancioso ni orgulloso. No se comporta con rudeza, no es egoísta, no se enoja fácilmente, no guarda rencor. El amor no se deleita en la maldad, sino que se regocija con la verdad. Todo lo disculpa, todo lo cree, todo lo espera, todo lo soporta."
            </p>

            <div className="verse-divider"></div>

            <p className="verse-reference">
              1 Corintios 13:4-7
            </p>
          </div>

          <div className="verse-decorative-line">
            <span className="decorative-dot"></span>
            <span className="decorative-line"></span>
            <span className="decorative-dot"></span>
          </div>

          <p className="verse-message">
            Que este amor sea el fundamento de nuestro matrimonio y guía en nuestro camino juntos.
          </p>
        </div>
      </div>

      {/* Bottom spacing */}
      <div className="bible-verse-bottom"></div>
    </section>
  );
};

export default BibleVerse;
